import React from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderTwo";
import BottomFooter from "../components/BottomFooter";
import ResetPassword from "../components/ResetPassword";
import ColorInit from "../helper/ColorInit";


const ResetPasswordPage = () => {

    return (
        <>
            <ColorInit color={true} />
            <Preloader />
            <HeaderOne category={true} />
            <ResetPassword />
            <BottomFooter />
        </>
    );
};

export default ResetPasswordPage;
